export const CheckmarkSmallIcon = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 10">
        <path d="M.685 4.991l3.382 3.382 7.248-7.247" strokeWidth="2" fill="none"></path>
    </svg>
);
